module.exports = __webpack_public_path__ + "assets/img/desc-bg.aa6c4f5b.png";